import React, { memo, useContext, useEffect, useState } from 'react'
import { AiOutlineClose } from '@react-icons/all-files/ai/AiOutlineClose'
import { useSelector } from 'react-redux'

import Button from 'components/common/button'
import { Container, useDialog } from 'components/common/modal/Modal'
import SignInOptions from 'components/signIn/CombinedSignIn'
import ResetPassword from 'components/signIn/ResetPassword'
import ResetSuccess from 'components/signIn/ResetSuccess'
import { LanguageContext } from 'context/LanguageContext'
import { getCDNURL } from 'network/api/networkSettings'

export const SignInForm = memo(({ signInFromBasket, show, hide }) => {
    const [step, setStep] = useState(1)
    const nextStep = () => setStep(step + 1)
    const cancelStep = () => setStep(step - 1)

    useEffect(() => {
        show && (document.body.style.overflow = 'hidden')
        return () => {
            document.body.style.overflow = ''
        }
    }, [show])

    switch (step) {
        case 1: {
            return (
                <SignInOptions
                    nextStep={nextStep}
                    cancelStep={cancelStep}
                    hide={hide}
                    show={show}
                    signInFromBasket={signInFromBasket}
                />
            )
        }
        case 2: {
            return <ResetPassword nextStep={nextStep} cancelStep={cancelStep} hide={hide} />
        }
        case 3: {
            return <ResetSuccess hide={hide} />
        }
        default:
            return <SignInOptions nextStep={nextStep} hide={hide} />
    }
})

const SignIn = props => {
    const { strings } = useContext(LanguageContext)

    const { on, hide, show, getToggleProps, getContainerProps } = useDialog()

    const newUserFaceBook = useSelector(state => state.authentication.getIn(['newUserFaceBook']))
    const isLoading = useSelector(state => state.languageChange.get('isLoading'))

    useEffect(() => {
        if (
            newUserFaceBook &&
            newUserFaceBook.toJS().first_name &&
            newUserFaceBook.toJS().last_name
        ) {
            hide()
        }
    }, [newUserFaceBook])

    return (
        <>
            <Button
                {...getToggleProps()}
                className={props.fromPanelFooter ? null : 'signin'}
                disabled={props.showSpinner ? true : false}
            >
                {props.showSpinner ? (
                    <img
                        className="basket-footer-loading"
                        src={getCDNURL() + 'assets/gifs/spinner.gif'}
                        alt={strings.spinnerAltTag}
                    />
                ) : <span className='signin_text'>{props.labelText || isLoading ? (
                    'Sign In'
                ) : (
                    strings.signinButton
                )}</span>}
            </Button>

            {on && (
                <Container {...getContainerProps()}>
                    <div className="signinform">
                        <Button
                            {...getToggleProps()}
                            aria-label="close modal"
                            className="closeModal"
                        >
                            <AiOutlineClose className="close" color="#00805F" size="2.5rem" />
                        </Button>
                        <SignInForm
                            hide={hide}
                            show={show}
                            signInFromBasket={props.signInFromBasket}
                        />
                    </div>
                </Container>
            )}
        </>
    )
}

export default SignIn
